import * as yup from "yup";

export const loginSchema = yup.object().shape({
    email: yup.string().email().required("Field is required"),
    password: yup.string().required("Field is required"),
});
